import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPaperPlane, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

/**
 * TurneroForgotPassword - Component to request password reset link
 */
const TurneroForgotPassword = ({ onBack, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'turnero/forgot-password', { email }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Enlace enviado. Revisa tu correo.' });
                if (onSuccess) onSuccess();
            } else {
                Notify({ type: 'fail', text: r.msg || 'Error al procesar la solicitud' });
            }
            setLoading(false);
        }, 'json', err => {
            Notify({ type: 'fail', text: 'Error de conexión' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <button 
                type="button" 
                className="btn btn-link text-white-50 p-0 mb-4 text-decoration-none" 
                onClick={onBack}
            >
                <FontAwesomeIcon icon={faArrowLeft} /> Volver al login
            </button>

            <h1 className="auth-title">Recuperar Acceso</h1>
            <p className="auth-subtitle">Ingresa tu email y te enviaremos un link para restablecer tu contraseña.</p>

            <form onSubmit={handleSubmit}>
                <div className="auth-input-group mb-4">
                    <input
                        type="email"
                        className="auth-input"
                        placeholder="Tu email registrado"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                    />
                    <FontAwesomeIcon icon={faEnvelope} className="auth-input-icon" />
                </div>

                <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : (
                        <><FontAwesomeIcon icon={faPaperPlane} /> Enviar Instrucciones</>
                    )}
                </button>
                
                <div className="p-3 bg-glass-dark border-radius-12 mt-2">
                    <small className="text-white" style={{ opacity: 0.6 }}>
                        Asegúrate de revisar también tu carpeta de correo no deseado (Spam).
                    </small>
                </div>
            </form>
        </div>
    );
};

export default TurneroForgotPassword;
